module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-faded",
    attrs: {
      "id": "portfolio"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('h2', {
    staticClass: "section-heading"
  }, [_vm._v("Screenshots")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subheading text-muted"
  }, [_vm._v("See what it looks like!")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6 portfolio-item"
  }, [_c('a', {
    staticClass: "portfolio-link",
    attrs: {
      "href": "#portfolioModal1",
      "data-toggle": "modal"
    }
  }, [_c('div', {
    staticClass: "portfolio-hover"
  }, [_c('div', {
    staticClass: "portfolio-hover-content"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-3x"
  })])]), _vm._v(" "), _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("../../assets/img/screenshot-connected-01.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "portfolio-caption"
  }, [_c('h4', [_vm._v("Collections")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Lists of videos you want to share or that are available for you to watch.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 portfolio-item"
  }, [_c('a', {
    staticClass: "portfolio-link",
    attrs: {
      "href": "#portfolioModal1",
      "data-toggle": "modal"
    }
  }, [_c('div', {
    staticClass: "portfolio-hover"
  }, [_c('div', {
    staticClass: "portfolio-hover-content"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-3x"
  })])]), _vm._v(" "), _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("../../assets/img/screenshot-connected-03.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "portfolio-caption"
  }, [_c('h4', [_vm._v("Streaming")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Choose a video and watch it in streaming in a real peer-to-peer manner.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 portfolio-item"
  }, [_c('a', {
    staticClass: "portfolio-link",
    attrs: {
      "href": "#portfolioModal1",
      "data-toggle": "modal"
    }
  }, [_c('div', {
    staticClass: "portfolio-hover"
  }, [_c('div', {
    staticClass: "portfolio-hover-content"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-3x"
  })])]), _vm._v(" "), _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("../../assets/img/screenshot-connected-02.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "portfolio-caption"
  }, [_c('h4', [_vm._v("Chat")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("You can also chat with four friends in a peer-to-peer encrypted way.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b851382"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/PortfolioGrid.vue
// module id = 109
// module chunks = 1